import React, { useEffect } from "react";
import styled from "styled-components";
import ImageOptionSelect from "./ImageOptionSelect";
import _ from "lodash";

export default function ImageOption({ optionsUtility, option }) {
  const selectedOption = _.find(option.values, { selected: true });
  const getSelectedLabel = () => {
    if (selectedOption.price && selectedOption.price > 0) {
      return selectedOption.label + " + $" + selectedOption.price;
    } else {
      return selectedOption.label;
    }
  };
  const isAB = window.is_ab_custom_pdp;
  return (
    <Container id="optionImages">
      {(isAB) && (
      <OptionContainerAB>
        {option.values.map((value) => {
          return (
            <ImageOptionSelect
              isab={isAB}
              option={option}
              value={value}
              optionsUtility={optionsUtility}
              key={value.label}
              id={option.handle}
            />
          );
        })}
      </OptionContainerAB>
      ) || (
      <OptionContainer>
        {option.values.map((value) => {
          return (
            <ImageOptionSelect
              isab={isAB}
              option={option}
              value={value}
              optionsUtility={optionsUtility}
              key={value.label}
              id={option.handle}
            />
          );
        })}
      </OptionContainer>
      )}
      
      <SelectedLabel>{getSelectedLabel()}</SelectedLabel>
    </Container>
  );
}

const SelectedLabel = styled.p`
  margin: 0;
  font-weight: 800;
  padding-top: 16px;
  padding-left: 5px;
`;
const OptionContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 12px;
`;
const OptionContainerAB = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 16px;
  @media screen and (max-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`;
